import {Theme, createStyles} from '@material-ui/core';

export const contactUsFormStyles = (theme: Theme) =>
	createStyles({
		wrapper: {
			width: '100%',
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.light,
			padding: theme.spacing(9),
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			borderRadius: theme.typography.pxToRem(40),
			position: 'relative',

			[theme.breakpoints.down('xs')]: {
				borderRadius: theme.typography.pxToRem(0),
				borderBottomRightRadius: theme.typography.pxToRem(40),
				borderTopRightRadius: theme.typography.pxToRem(40),
				padding: theme.spacing(7, 2.5),
				marginBottom: theme.spacing(3),
			},
		},
		formTitle: {
			textAlign: 'center',
			textTransform: 'uppercase',
			fontSize: theme.typography.pxToRem(28),
			lineHeight: theme.typography.pxToRem(24),
			letterSpacing: theme.typography.pxToRem(1.2),
			color: theme.palette.common.white,
			margin: 0,
			marginBottom: theme.spacing(2),

			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(20),
				marginBottom: theme.spacing(1),
			},
		},
		formSubTitle: {
			textAlign: 'center',
			maxWidth: '260px',
			color: theme.palette.common.white,
			lineHeight: theme.typography.pxToRem(24),
			marginBottom: theme.spacing(5),

			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(12),
				maxWidth: '240px',
				lineHeight: theme.typography.pxToRem(18),
				marginBottom: theme.spacing(2.5),
			},
		},
		input: {
			backgroundColor: theme.palette.primary.light,
			marginBottom: theme.spacing(2),
			fontSize: theme.typography.pxToRem(15),
			color: theme.palette.primary.main,
			'& > .MuiInputLabel-formControl': {
				fontSize: theme.typography.pxToRem(14),
			},
			'& > .Mui-error': {
				backgroundColor: theme.palette.error.light,
			},
			'&:hover .MuiFilledInput-underline:after': {
				borderColor: theme.palette.secondary.main,
				transform: 'scaleX(1)',
			},
			'& > .MuiFilledInput-root': {
				paddingRight: theme.typography.pxToRem(120),
			},
			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(12),
			},
		},
		helperText: {
			position: 'absolute',
			color: theme.palette.error.main,
			top: '50%',
			transform: 'translate(0, -50%)',
			right: 0,
			fontSize: theme.typography.pxToRem(10),
		},
		buttonSubmit: {
			width: '100%',
			color: theme.palette.primary.main,
			fontSize: theme.typography.pxToRem(14),
			letterSpacing: theme.typography.pxToRem(1.2),
			marginBottom: theme.spacing(2),

			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(12),
				marginBottom: theme.spacing(2.5),
			},
		},
		formDescription: {
			maxWidth: '260px',
			fontSize: theme.typography.pxToRem(12),
			textAlign: 'center',
		},
		square: {
			display: 'none',
			[theme.breakpoints.down('xs')]: {
				display: 'block',
				backgroundColor: theme.palette.primary.main,
				width: 34,
				height: 34,
				position: 'absolute',
				top: '100%',
				left: 0,
			},
		},
		sphere: {
			display: 'none',
			[theme.breakpoints.down('xs')]: {
				position: 'absolute',
				display: 'block',
				left: 0,
				top: 0,
				width: 68,
				height: 68,
				borderRadius: '50%',
				backgroundColor: theme.palette.background.default,
			},
		},
	});
